import type { IconName } from "@@/shared/icon-name";
import type {
    TranslatableValue} from "@@/shared/translations/translation";
import {
    translation,
} from "@@/shared/translations/translation";
import { toObjectMap } from "@@/utilities/dictionary";
import { z } from "zod";

const accommodationPurposes = [
    "LEISURE",
    "BUSINESS",
    "GROUP",
    "CONFERENCE",
] as const;
type AccommodationPurpose = (typeof accommodationPurposes)[number];
const accommodationPurpose = toObjectMap<AccommodationPurpose>([
    ...accommodationPurposes,
]);
const accommodationPurposeZodSchema = z.enum(accommodationPurposes);

type AccommodationPurposeMeta = {
    [key in AccommodationPurpose]: {
        iconName: IconName;
        title: TranslatableValue;
        shortDescription: TranslatableValue;
    };
};
const accommodationPurposeMeta: AccommodationPurposeMeta = {
    LEISURE: {
        iconName: "fa-island-tropical",
        title: translation({
            sv: "Nöjesresa",
            en: "Leisure",
        }),
        shortDescription: translation({
            sv: "Nöjesresa, fritid",
            en: "Leisure trip or similar",
        }),
    },
    BUSINESS: {
        iconName: "fa-briefcase",
        title: translation({
            sv: "Affärer",
            en: "Business",
        }),
        shortDescription: translation({
            sv: "Affärsresa",
            en: "Business trip",
        }),
    },
    GROUP: {
        iconName: "fa-people-group",
        title: translation({
            sv: "Gruppresa",
            en: "Group trip",
        }),
        shortDescription: translation({
            sv: "Gruppresa",
            en: "Group trip",
        }),
    },
    CONFERENCE: {
        iconName: "fa-handshake",
        title: translation({
            sv: "Konferens",
            en: "Conference",
        }),
        shortDescription: translation({
            sv: "Konferens",
            en: "Conference",
        }),
    },
};

export {
    accommodationPurpose,
    accommodationPurposeMeta,
    accommodationPurposeZodSchema,
    accommodationPurposes,
};
export type { AccommodationPurpose };
